import React, { useEffect, useMemo, useState } from 'react';
import { useLogout, usePermissions, useRedirect } from 'react-admin';
import { useSelector } from 'react-redux';
import { Dashboard } from '../../pages';
import { authGet } from '../../server';

const FACILITY_FETCH_MAX_ATTEMPTS = 5;
const FACILITY_FETCH_RETRY_DELAY_MS = 200;

export const DashboardHome = () => {
  const [facilityIds, setFacilityIds] = useState([]);
  const userId = useSelector(state => state.user.profile.id);
  const { permissions = '' } = usePermissions();
  const userPermissions = useMemo(() => permissions.split(','), [permissions]);
  const isContractUser = userPermissions.indexOf('contract_user') > -1;
  const redirect = useRedirect();
  const logout = useLogout();
  const coveredUserId = useSelector(state => state.facility.covered_user_id);
  const dashboardUserId = coveredUserId || userId;

  useEffect(() => {
    if (isContractUser) {
      redirect('/payers-facility');
    }
  }, [isContractUser, redirect]);

  useEffect(() => {
    if (!dashboardUserId || isContractUser) {
      return undefined;
    }
    let isMounted = true;
    let retryTimeoutId;

    const fetchData = async (attempt = 1) => {
      const facilities = await authGet([
        `/facilities/list`,
        {
          caseManagerId: dashboardUserId,
        },
      ]);

      if (!isMounted) {
        return;
      }
      if (facilities.status === 200 && Array.isArray(facilities.data)) {
        const ids = facilities.data.map(row => row.id);
        setFacilityIds(ids);
        return;
      }
      if (attempt >= FACILITY_FETCH_MAX_ATTEMPTS) {
        if (facilities.status === 403) {
          logout();
        }
        return;
      }
      retryTimeoutId = window.setTimeout(() => {
        fetchData(attempt + 1);
      }, FACILITY_FETCH_RETRY_DELAY_MS);
    };
    setFacilityIds([]);
    fetchData();

    return () => {
      isMounted = false;
      if (retryTimeoutId) {
        window.clearTimeout(retryTimeoutId);
      }
    };
  }, [dashboardUserId, isContractUser, logout]);
  // TODO: determine if we can implement route based permissions (only white listed routes)
  if (isContractUser) return null;
  return dashboardUserId && facilityIds.length ? (
    <Dashboard
      title='My Dashboard'
      viewMultiple={true}
      facility_ids={facilityIds}
      user_id={dashboardUserId}
      home={true}
    />
  ) : null;
};
